import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import "./NavButton.scss";

const NavButton = (props) => {
	const { onClick, disabled, previous, next } = props;

	const buttonClasses = classnames({
		"important-questions-nav-button": true,
		prev: previous,
		next: next,
	});

	return (
		<button
			className={buttonClasses}
			disabled={disabled}
			onClick={onClick}
		>
			<span className="important-questions-nav-button-text">
				{previous &&
					<span>previous</span>
				}
				{next &&
					<span>next</span>
				}
				{" "}
				question
			</span>
			<div className="important-questions-nav-button-icon" />
		</button>
	);
};

NavButton.propTypes = {
	previous: PropTypes.bool,
	next: PropTypes.bool,
	disabled: PropTypes.bool,
	onClick: PropTypes.func.isRequired,
};

export default NavButton;



// WEBPACK FOOTER //
// ./src/apps/discovery/components/headers/ImportantQuestions/NavButton.jsx